/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react"
import { T区分分類コード } from "../../constant/enum/codes"
import { 区分マスタ } from "../../service/master/kubun/TKubun"
import { defaultComboBoxTextFormatter } from "../../ts/util/commonUtil"
import BaseComboBox, { TExtendedBaseComboBoxProps } from "./BaseComboBox"

//TODO:ダミー用に配置
export type T区分マスタ = 区分マスタ

// コンボボックスでの表示対象となるアイテムの型定義をここに記載
type TItem = T区分マスタ & { name?: string }

const displayNameProperty: keyof TItem = "name"
// コンボボックスの表示名とするプロパティ名
const displayField: keyof TItem = "名称1"
// 表示名のデフォルトフォーマッタ
const defaultDisplayTextFormatter = defaultComboBoxTextFormatter

// コンボボックスの選択値となるプロパティ名
const valueField: keyof TItem = "区分コード"

// 全選択の選択用アイテム生成処理
const createAllSelectItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = `すべて`
  // 全選択時の値
  obj[valueField] = ""
  return obj
}

// 未選択用のアイテム生成処理
const createEmptyItem = () => {
  const obj = {} as TItem
  // 全選択の表示名
  obj[displayField] = ``
  // 全選択時の値
  obj[valueField] = ""
  return obj
}

/**
 * 区分ComboBox
 * @param props
 * @returns
 */
export const KubunComboBox: React.FC<
  TExtendedBaseComboBoxProps<string, T区分マスタ> & {
    分類コード?: T区分分類コード
  }
> = (props) => {
  // state
  const [innerItemsSource, setInnerItemsSource] = useState<Array<TItem>>([])

  // nameプロパティ追加処理
  const appendNameProperty = (data: TItem[]) => {
    // any型で処理することで name プロパティを追加
    data.forEach((value: TItem) => {
      value[displayNameProperty] = props.displayTextFormatter
        ? props.displayTextFormatter(value)
        : defaultDisplayTextFormatter(value, valueField, displayField)
    })
  }

  // 初期値がある場合の設定処理
  const setDefaultValue = (data: TItem[]) => {
    if (props.defaultValue) {
      const firstData = data.find((d) => {
        return d[valueField] === props.defaultValue
      })
      if (firstData != null) {
        props.setText && props.setText(firstData[displayNameProperty] ?? "")
        props.setSelectedItem && props.setSelectedItem(firstData)
        props.setSelectedValue && props.setSelectedValue(firstData[valueField])
      }
    }
  }
  // itemsSource更新時に選択Itemを先頭のitemに変更
  const setFirstValue = (data: TItem[]) => {
    const firstData = data.length > 0 ? data[0] : undefined
    if (firstData != null) {
      props.setText && props.setText(firstData[displayNameProperty] ?? "")
      props.setSelectedItem && props.setSelectedItem(firstData)
      props.setSelectedValue && props.setSelectedValue(firstData[valueField])
    }
  }
  // 初期設定
  useEffect(() => {
    // itemsSource検索開始フラグ
    if (
      props.itemsSource != null &&
      props.itemsSource.length > 0 &&
      props.ComboBox != null &&
      props.isLoadEnded === false
    ) {
      // 区分のみ外部より与えられた分類コードで絞り込む
      let data = props.itemsSource
        .filter(
          props.分類コード
            ? (i) => i.分類コード === props.分類コード
            : () => true
        )
        .filter(props.listFilter ? props.listFilter : () => true)
      if (props.isAllSelect) {
        data.splice(0, 0, createAllSelectItem())
      } else if (props.isEmpty) {
        data.splice(0, 0, createEmptyItem())
      }

      // デフォルトラベルを設定
      appendNameProperty(data)
      setInnerItemsSource(data)
      setDefaultValue(data)

      props.setIsLoadEnded(true)
    }
  }, [props.itemsSource, props.ComboBox, props.isLoadEnded])

  // itemsSourceと分類コード更新時
  useEffect(() => {
    if (
      props.itemsSource != null &&
      props.itemsSource.length > 0 &&
      props.ComboBox != null &&
      props.isLoadEnded
    ) {
      // 区分のみ外部より与えられた分類コードで絞り込む
      let data = props.itemsSource
        .filter(
          props.分類コード
            ? (i) => i.分類コード === props.分類コード
            : () => true
        )
        .filter(props.listFilter ? props.listFilter : () => true)
      if (props.isAllSelect) {
        data.splice(0, 0, createAllSelectItem())
      } else if (props.isEmpty) {
        data.splice(0, 0, createEmptyItem())
      }

      appendNameProperty(data)
      setInnerItemsSource(data)
      // データを更新
      setFirstValue(data)
    }
  }, [props.itemsSource, props.分類コード])

  // 必要項目を渡したBaseComboBoxを返却
  return (
    <>
      <BaseComboBox
        displayField={displayNameProperty}
        valueField={valueField}
        {...props}
        itemsSource={innerItemsSource}></BaseComboBox>
    </>
  )
}
